"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  prdays: {
    index: '序号',
    itemid: '编码',
    pyear: '发布年份',
    stoped: '是否启用',
    stddays: '记薪天数',
    slydays: '工作日天数',
    remark: '备注',
    add: '新增',
    del: '删除',
    edit: '编辑',
    print: '输出',
    table: '表格',
    stamp: '打印',
    enable: '启用',
    stop: '停止',
    payrollManagement: '薪酬管理',
    basicData: '基础数据',
    basicInfo: '基础信息',
    payableDaysMaintenance: '计薪天数维护',
    submitted: '已提交',
    unSubmitted: '未提交',
    hint: '提示',
    confirm: '确定',
    cancel: '取消',
    delSuc: '删除成功',
    delFail: '删除失败',
    delCancel: '已取消删除',
    selectOneData: '请选择至少一条数据',
    payableDaysMaintenanceData: '计薪天数维护数据',
    save: '保存',
    submit: '提交',
    yes: '是',
    no: '否',
    goBack: '退回',
    cmt: '状态',
    operateInfo: '操作信息',
    createInfo: '创建信息',
    modifyInfo: '修改信息',
    submitInfo: '提交信息',
    message1: '请选择需要删除的行',
    message2: '此操作将永久删除该条数据',
    message3: '系统可能不会保存您所做的更改',
    message4: '请填写发布年份',
    message5: '发布年份不能小于4位数',
    message6: '记薪天数整数不可大于3位数',
    message7: '保存成功',
    message8: '保存失败',
    message9: '异常',
    message10: '关闭窗口',
    message13: '请填写记薪天数',
    message14: '请填写工作日天数',
    message15: '不可删除已提交数据',
    message16: '工作日天数整数不可大于3位数'
  }
};